import styled from 'styled-components';

export const Button = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  background: transparent;
`;
